<template>
    <div class="image-admin-list card p-4">
        <h4 class="card-title">Lista de Imágenes</h4>
        <b-alert v-if="loadingError" show variant="danger">
            {{ loadingError }}
        </b-alert>

        <div v-if="loading" class="text-center">
            <b-spinner label="Cargando..."></b-spinner>
        </div>

        <div v-else>
            <div v-if="images.length === 0" class="alert alert-info text-center">
                No hay imágenes subidas aún.
            </div>
            <div v-else class="row">
                <div v-for="image in images" :key="image.id" class="col-md-4 col-sm-6 mb-4">
                    <div class="card image-card h-100">
                        <img :src="getImageUrl(image.filepath)" class="card-img-top" :alt="image.filename" style="object-fit: contain; height: 200px;">
                        <div class="card-body d-flex flex-column">
                            <h6 class="card-title">{{ image.filename }}</h6>
                            <p class="card-text text-muted small">ID: {{ image.id }}</p>
                            <p class="card-text text-muted small">Subida: {{ formatDate(image.uploaded_at) }}</p>
                            <div class="mt-auto text-end">
                                <b-button variant="danger" size="sm" @click="requestDelete(image.id)">
                                    <font-awesome-icon icon="trash-can" /> Eliminar
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, defineEmits, defineProps } from 'vue'; // Añadir defineProps
import { BAlert, BSpinner, BButton } from 'bootstrap-vue-next';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { listImages } from '../../../services/imageService.js';
import { API_BASE_URL } from '../../../config';

const emit = defineEmits(['delete-image', 'load-error']);

const images = ref([]);
const loading = ref(true);
const loadingError = ref(null);

const props = defineProps({
    refreshCounter: {
        type: Number,
        default: 0
    }
});

watch(() => props.refreshCounter, () => {
    fetchImages();
});

onMounted(() => {
    fetchImages();
});

async function fetchImages() {
    loading.value = true;
    loadingError.value = null;
    try {
        const token = localStorage.getItem('jwt_token');
        if (!token) {
            loadingError.value = "No autenticado. Por favor, inicia sesión de nuevo.";
            emit('load-error', loadingError.value);
            return;
        }
        const data = await listImages(token); // Usar el token
        images.value = data;
    } catch (err) {
        loadingError.value = `Error al cargar imágenes: ${err.message}`;
        emit('load-error', loadingError.value);
    } finally {
        loading.value = false;
    }
}

function getImageUrl(filepath) {
    if (typeof filepath !== 'string' || filepath.length === 0) {
        // console.warn("filepath inválido:", filepath); // Eliminado
        return '';
    }

    const publicPathSegment = filepath.substring(filepath.indexOf('/public/') + '/public/'.length);
    const apiBaseUrlObj = new URL(API_BASE_URL);
    const baseUrl = `${apiBaseUrlObj.protocol}//${apiBaseUrlObj.host}`;

    return `${baseUrl}/public/${publicPathSegment}`;
}

function formatDate(dateString) {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
}

function requestDelete(imageId) {
    emit('delete-image', imageId);
}

</script>

<style scoped>
.image-admin-list {
    /* Estilos específicos para la lista de imágenes */
}

.image-admin-list:hover {
    transform: none !important;
    box-shadow: none !important;
}
</style>